module.exports = __webpack_public_path__ + "static/media/view6.0a96ece8.jpg";